<template>
  <div class='info'>
    <div class="title">
      <img src="@/assets/joinus/recruit/title.png" alt="">
    </div>

    <div class="top">
      <div class="top-div">
        <div class="left">
          <div class="tit">
            <span class="name">{{ info.job_name }}</span>
            <span v-if="info.is_hot === 1" class="hot">热招</span>
            <span class="type">{{ info.class_name }}</span>
          </div>
          <div class="bot">
            <span>{{ info.job_location }}</span>
            <span>{{ info.publish_time.slice(0, 10) }}发布</span>
            <span>{{ info.education }}</span>
            <span>{{ info.experience }}</span>
            <span>招聘{{ info.need_num === 0? '若干': info.need_num }}人</span>
          </div>
        </div>
      </div>
    </div>

    <div class="duty">
      <div class="title">工作职责</div>
      <div class="text" v-html="info.duty"></div>
    </div>

    <div class="duty">
      <div class="title">任职要求</div>
      <div class="text" v-html="info.requirement"></div>
    </div>
    <div class="tips">
      感谢您把简历发送至 <a class="mailLink" href="mailto:heyunpeng@skshu.com.cn">heyunpeng@skshu.com.cn</a> 邮箱，邮件主题格式为【姓名_招聘职位】，附件为个人简历，文件名为【姓名简历】。如有面试需求，我们会通过电话或邮件方式及时联系您，请留意您的电话或邮箱，以免错过面试机会。
    </div>
  </div>
</template>

<script>
import axios from 'axios'
const md5 = require('js-md5')
import qs from 'qs'
import Des from '@/util/des.js'

export default {
  components: {
  },
  data() {
    return {
      info: {
        publish_time: ''
      },
    }
  },
  computed: { },
  watch: {},
  created() {
    this.getInfo()
  },
  mounted() {
  },
  methods: {
    getInfo() {
      const stamp = Date.now()
      const data = {
        stamp,
        id: this.$route.query.id,
        sign: md5(this.$route.query.id + '' + stamp + atob(localStorage.getItem('okey')))
      }
      axios.post('/api/xiaosen/user/info/recruitJobInfo', qs.stringify(data)).then(res => {
        if (res.data.result === 1) {
          console.log(res)
          const deskey = atob(localStorage.getItem('odeskey'))
          this.info = JSON.parse(Des.decryptByDES(res.data.data, deskey))
          console.log(this.info)
        } else {
          this.$message(res.data.msg)
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.info {
  margin: 0 auto;
  width: 100%;
  max-width: 1920px;
  .title{
    width: 100%;
    max-width: 1920px;
    img{
      width: 100%;
      vertical-align: top;
    }
  }

  .top{
    box-sizing: border-box;
    width: 100%;
    max-width: 1920px;
    height: 195px;
    background: #F5F8F4;
    font-size: 20px;
    text-align: left;
    margin-bottom: 60px;
    .top-div{
      display: flex;
      width: 1440px;
      align-items: center;
      margin: 0 auto;
      height: 100%;
    }
    .left{
      flex: 1;
      .tit{
        display: flex;
        align-items: center;
        margin-bottom: 47px;
        .name{
          font-size: 36px;
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          color: #4E8B46;
          margin-right: 20px;
        }
        .hot{
          width: 67px;
          text-align: center;
          height: 28px;
          line-height: 28px;
          background: #009538;
          border-radius: 14px 0 14px 0;
          font-size: 17px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #FFFFFF;
          margin-right: 20px;
        }
        .type{
          padding: 0 20px;
          height: 32px;
          line-height: 32px;
          background: #DBEED9;
          border-radius: 5px;
          font-size: 20px;
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          color: #4E8B46;
        }
      }
    }
    button{
      width: 160px;
      height: 48px;
      background: #4E8B46;
      border-radius: 5px;
      border: 0;
      font-size: 24px;
      font-family: FZLanTingHeiS-R-GB;
      font-weight: 400;
      color: #FFFFFF;
    }
  }

  .bot{
    color: #595858 ;
    span{
      padding: 0 20px;
      border-right: 1px solid #E4E4E4;
    }
    span:nth-child(1) {
      padding-left: 0;
    }
    span:last-child {
      border: 0;
    }
  }
  .duty{
    margin: 0 auto;
    width: 1440px;
    text-align: left;
    margin-bottom: 61px;
    .title{
      font-size: 24px;
      font-family: FZLanTingHeiS-DB-GB;
      font-weight: 400;
      color: #4E8B46;
      margin-bottom: 30px;
    }
    .text{
      font-size: 20px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #595858;
      line-height: 36px;
      white-space: pre;
    }
  }
  .tips {
    width: 1365px;
    background: #F5F8F4;
    border-radius: 30px;
    text-indent: 2em;
    padding: 49px 38px;
    font-size: 24px;
    font-family: FZLanTingHeiS-R-GB;
    font-weight: 400;
    color: #333333;
    line-height: 42px;
    margin: 0 auto 56px;
    text-align: left;
    .mailLink {
      color: #333333;
    }
  }
  /deep/ .el-dialog {
    width: 865px;
    position: absolute;
    top: 34px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    padding: 75px 50px;
    border-radius: 30px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      .dialog-box {
        position: relative;
        .title {
          font-size: 48px;
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          color: #4E8B46;
          line-height: 60px;
          margin-bottom: 45px;
          text-align: center;
        }
        .desc {
          width: 1441px;
          height: 213px;
          background: #F5F8F4;
          border-radius: 30px;
          text-indent: 2em;
          padding: 49px 38px;
        }
        .closebtn {
          width: 70px;
          height: 70px;
          position: absolute;
          top: -75px;
          right: -220px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
